import { dataSearchState } from "./state";

/** Ids of the picked company / location chips, as the saved-search payload stores them. */
export const locationAndCompanyDomainPayloadCreation = () => {
  const { companyDomain = [], location = [], companyLocation = [] } = dataSearchState?.selectedFilteredList || {};
  const companyDomainArr = (companyDomain || []).map(item => item?.id);
  const locationArr = (location || []).map(item => item?.id);
  const companyLocationArr = (companyLocation || []).map(item => item?.id);
  return { companyDomainArr, locationArr, companyLocationArr };
};

// The current filters in saved-search shape: filter values plus the chips List Builder restores them with.
export const currentSearchState = (savedpayload = {}) => {
  const { companyDomainArr = [], locationArr = [], companyLocationArr = [] } = savedpayload || {};
  const selected = dataSearchState?.selectedFilteredList || {};
  const companies = (selected.companyDomain || []).map(({ id = "", name = "", primaryDomain = "" }) => ({
    id,
    name,
    primaryDomain
  }));
  const toChip = ({ id = "", name = "", group = "", searchText = [] }) => ({ id, name, group, searchText });
  const locations = (selected.location || []).map(toChip);
  const companyLocations = (selected.companyLocation || []).map(toChip);

  return {
    ...dataSearchState.filterComponentData,
    locationIds: locationArr,
    companyId: companyDomainArr,
    companyLocationIds: companyLocationArr,
    locations,
    companies,
    companyLocations
  };
};

/** The current filters as a plain saved-search state object (detached from the store). */
export const getCurrentSearchState = () =>
  JSON.parse(JSON.stringify(currentSearchState(locationAndCompanyDomainPayloadCreation())));
